module.exports = __webpack_public_path__ + "img/b4.c393656f.jpg";